/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deviceTypesList.vue?vue&type=template&id=0b24bb2e"
import script from "./deviceTypesList.vue?vue&type=script&lang=js"
export * from "./deviceTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports